<template>
  <div id="loader-wrapper">
    <errorHeader></errorHeader>
    <!-- <video id='pageVideo' class="video" muted="muted" autoplay="autoplay" loop='loop' preload>
			<source src="https://cdn.tikcos.cn/bg/loading_video.mp4" type="video/mp4" />
			您的浏览器不支持 video 标签。
		</video> -->
    <div class="preloader" id="preloader">
      <div class="loader loader-1">
        <div class="loader-outter"></div>
        <div class="loader-inner"></div>
      </div>
    </div>
    <div class="load_title">
      正在加载&nbsp;WEIIT新零售&nbsp;系统，请耐心等待...
    </div>
    <copyFooter color="#fff"></copyFooter>
  </div>
</template>
<script>
import errorHeader from '../components/errorHeader.vue'
import copyFooter from '../components/copyFooter.vue'
import { getUrlParam } from '@/utils/util'
export default {
  name: 'load',
  data() {
    return {}
  },
  components: {
    copyFooter,
    errorHeader,
  },
  methods: {

  },
}
</script>
<style lang="scss" scoped="scoped">
.video {
  width: 767px;
  height: 767px;
  background-size: 100% 100%;
  position: absolute;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 46%;
  transform: translate(-50%, -50%);
  mix-blend-mode: screen;
}

::-webkit-scrollbar {
  width: 1px;
  height: 1px;
}

#loader-wrapper {
  background: url('https://cdn.tikcos.cn/bg/loading_bg.png') no-repeat 0px 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: 100% 100%;
}

#loader-wrapper .load_title {
  font-family: 'Open Sans';
  color: #fff;
  font-size: 14px;
  width: 100%;
  text-align: center;
  z-index: 9999999999999;
  position: absolute;
  top: 58%;
  opacity: 1;
  line-height: 30px;
}

.preloader {
  width: 500px;
  height: 500px;
  background-color: transparent;
  position: absolute;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
